"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ["ILX", "RDX", "RSX", "TL", "TLX", "TSX"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/fake-vehicle-apis/lib/models-acura.js
// module id = 110
// module chunks = 0